<template>
    <b-modal :id="modalId" size="xl" title="Preview Foto">
        <div class="modal-foto-wrapper">
            <img :src="fotoPreview" alt="Foto">
        </div>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                Close
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'modal-preview-foto',
    props: {
        fotoPreview: { type: String, required: true },
        modalId: { type: String, default:"modal-preview-foto" }
    }
}
</script>